import LocalizedStrings from 'localized-strings';

import { KYX_CHECK_REVIEW_STATUS, KYX_CHECK_STATUS } from 'helpers/kyx';

type KyxCheckReviewStatusLocale = Partial<{
  [reviewStatus in KYX_CHECK_REVIEW_STATUS]: string;
}>;

type KyxCheckStatusLocale = Partial<{
  [status in KYX_CHECK_STATUS]: string;
}>;

const locales = new LocalizedStrings({
  en: {
    badge: {
      reviewStatus: {
        [KYX_CHECK_REVIEW_STATUS.NONE]: 'Incomplete application',
        [KYX_CHECK_REVIEW_STATUS.INVALID]: 'Document refused',
      } as KyxCheckReviewStatusLocale,
      status: {
        [KYX_CHECK_STATUS.SUBMITTED]: 'Validation in progress',
      } as KyxCheckStatusLocale,
    },
    bankingDetails: 'Banking information',
    email: 'Email address',
    missingBankDetails:
      'Indicate to which account you wish to receive your refunds.',
    personalAddress: 'Personal address',
    previousAddress: 'Previous: ',
    terms: 'Terms of use',
  },
  fr: {
    badge: {
      reviewStatus: {
        [KYX_CHECK_REVIEW_STATUS.NONE]: 'Demande incomplete',
        [KYX_CHECK_REVIEW_STATUS.INVALID]: 'Document refusé',
      } as KyxCheckReviewStatusLocale,
      status: {
        [KYX_CHECK_STATUS.SUBMITTED]: 'En cours de validation',
      } as KyxCheckStatusLocale,
    },
    bankingDetails: 'Informations bancaires',
    email: 'Adresse e-mail',
    missingBankDetails:
      'Indiquez sur quel compte vous souhaitez recevoir vos remboursements.',
    personalAddress: 'Adresse personnelle',
    previousAddress: 'Ancienne : ',
    terms: 'Conditions générales d’utilisation',
  },
} as const);

export default locales;
